import { render, staticRenderFns } from "./operateRecord.vue?vue&type=template&id=74be0a1b&scoped=true&"
import script from "./operateRecord.vue?vue&type=script&lang=js&"
export * from "./operateRecord.vue?vue&type=script&lang=js&"
import style0 from "./operateRecord.vue?vue&type=style&index=0&id=74be0a1b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74be0a1b",
  null
  
)

export default component.exports